var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('BaseHeading',{attrs:{"heading-text":"プライベートコース"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }